import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'reactstrap';

import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Container>
        {/* Header Section */}
        <Row className="text-center mt-5">
          <Col>
            <h1 className="display-3">wattson_x</h1>
            <p className="lead">Professional Video Editor</p>
          </Col>
        </Row>

        {/* About Section */}
        <Row className="mt-5">
          <Col>
            <About />
          </Col>
        </Row>

        <Row className="mt-5">
          <Col>
            <Testimonials />
          </Col>
        </Row>

        <Row className="mt-5">
          <Col>
            <Contact />
          </Col>
        </Row>

        <Row className="text-center mt-5">
          <Col>
            <p>© 2024 wattson_x. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
